import React, { useEffect, useState } from 'react';
import { Button, Card, Carousel, Col, Collapse, Container, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';
import Topbar from '../../shared/components/Topbar';
import { useNavigate, useParams } from 'react-router-dom';
import NavbarComp from '../../shared/components/Navbar';
import { useAuth } from '../auth/hooks/useAuth';
import { useCategory } from './hooks/useCategory';
import { useProducts } from '../products/hooks/useProducts';
import ProductCategoryList from './components/ProductCategoryList';
import { useFavorite } from '../products/hooks/useFavorite';
import { useCarts } from '../products/hooks/useCart';
import Footer from '../../shared/components/Footer';

const CategoryPage = ({ tittle }) => {

    const { param } = useParams();

    const navigate = useNavigate();

    const { searchProductPost } = useProducts();
    const { addFavoriteProduct, removeFavoriteProduct } = useFavorite();
    const { addProductCart } = useCarts();

    const { productsSearchCategory,
        searchProductCategoryPost,
        loading } = useCategory();

    const bbb = productsSearchCategory

    const { validate } = useAuth();

    const [user, setUser] = useState()


    const [categoryProduct, setCategoryProduct] = useState([])


    const handleOnAddToCart = async (data) => {
        const rowDataAddCart = {
            qty: 1,
            product: data
        }
        await addProductCart(rowDataAddCart);
        navigate('/cart');
    }

    useEffect(() => {
        (async () => {
            // const userData = await validate();
            // setUser(userData);
            await searchProductCategoryPost(param)
        })();

    }, [validate, searchProductCategoryPost]);

    const handleSearchProduct = (value) => {
        searchProductPost(value)
    }

    return (
        <>
            {/* <Topbar /> */}
            <NavbarComp searchProduct={handleSearchProduct} />
            <Container style={{
                // backgroundColor: 'white',// Make sure the path is correct
                backgroundPosition: 'top right', // Position the image at the top-right corner
                backgroundSize: 'auto', // Adjust the size of the background image
                height: '100vh', // Make the container take full height (optional)    
                overflowY: 'auto',
                overflowX: 'hidden',
                // paddingBottom: '5%'
            }}>
                    <Row className='pt-5'>
                        <Col xs={12} md={12}>
                            <ProductCategoryList
                                products={bbb}
                                onAddToFavorites={addFavoriteProduct}
                                onAddToCart={handleOnAddToCart}
                                loading={loading} />
                        </Col>
                    </Row>
                <Footer />

            </Container>
        </>
    );
};

export default CategoryPage;
